<template>
 <label class="inline-flex bg-gray-01 rounded-7 py-[6px] px-2">
  <img
    :src="file"
    alt="search"
    class="mr-1"
  />
  <input
    type="file"
    hidden
    :accept="accept"
    @change="handleFileChange"
  />
  <span class="w-full text-gray-04 bg-gray-01 text-[10px]">
   {{ fileName || placeholder }}
  </span>
 </label>
</template>

<script setup>
import { ref } from 'vue';
import file from '@/assets/file.svg'

const props = defineProps({
 value: {
  type: [File, null],
  default: null
 },
 placeholder: {
  type: String,
  default: ''
 },
 accept: {
  type: String,
  default: ''
 }
})

const fileName = ref('')
const emits = defineEmits(['update:model-value'])
function handleFileChange(event) {
 const file = event.target.files[0];
 fileName.value = file.name
 emits('update:model-value', file)
}
</script>
